import { getSessionCookies } from 'portal-utils/session-cookies'
import {
  I18N_MOCK
} from 'portal-modules/common/constants/keys'
var DEFAULT_CODE = 'en_US'

export const setDefaultLocale = defaultCode => {
  DEFAULT_CODE = defaultCode || 'en_US'
}

const languageList = {
  af: 'Afrikaans',
  sq: 'Shqip',
  ar: '‎‫العربية‬‎',
  hy: 'հայերեն',
  az: 'Azərbaycan',
  eu: 'Euskara',
  be: 'беларуская',
  bg: 'български',
  ca: 'Català',
  zh: '中文',
  hr: 'Hrvatski',
  cs: 'čeština',
  da: 'Dansk',
  nl: 'Nederlands',
  en: 'English',
  et: 'Eesti',
  tl: 'Filipino',
  fi: 'Suomi',
  fr: 'Français',
  gl: 'Galego',
  ka: 'ქართული',
  de: 'Deutsche',
  el: 'Ελληνικά',
  ht: 'Kreyòl Ayisyen',
  iw: 'עברית',
  hi: 'हिंदी',
  hu: 'Magyar',
  is: 'Íslenska',
  id: 'Indonesia',
  ga: 'Gaeilge',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  lv: 'latviešu',
  lt: 'lietuvių',
  mk: 'македонски',
  ms: 'Melayu',
  mt: 'Malti',
  no: 'Norsk',
  fa: '‎‫فارسی‬‎',
  pl: 'Polski',
  pt: 'Português',
  ro: 'Română',
  ru: 'Pусский',
  sr: 'Cрпски',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  es: 'Español',
  sw: 'Kiswahili',
  sv: 'Svenska',
  th: 'ไทย',
  tr: 'Türkçe',
  uk: 'Yкраїнська',
  ur: '‎‫اردو‬‎',
  vi: 'Tiếng Việt',
  cy: 'Cymraeg',
  yi: 'Yiddish',
}

export const getLanguageNameFromLocale = locale => {
  const [lang, country] = locale.split('_')
  return `${languageList[lang]} (${country.toUpperCase()})`
}

export const getLocale = () => {
  const locale = getSessionCookies(I18N_MOCK) || DEFAULT_CODE

  return {
    locale,
    language: getLanguageNameFromLocale(locale),
  }
}
